// extracted by mini-css-extract-plugin
export default {"spinner":"LargeSpinner_spinner__jma9r","circle":"LargeSpinner_circle__y6d8R","path":"LargeSpinner_path__j61x7","dash":"LargeSpinner_dash__BSqHy"};